// This file is automatically generated. Do not edit manually.

import { DeliveryPackageWithSourcesView } from "src/api/generated/erp/db/types/tables/deliveryPackageWithSourcesView";
import { DeliveryPackageLineSourceType } from "src/api/generated/erp/db/types/enums/deliveryPackageLineSourceType";
import { DeliveryPackageSource } from "src/api/generated/erp/delivery/model/deliveryPackageSource";
import { Address } from "src/api/generated/erp/db/types/embeddables/address";
import { DeliveryPackageLineView } from "src/api/generated/erp/db/types/tables/deliveryPackageLineView";
import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { WarehouseLocationView } from "src/api/generated/erp/db/types/tables/warehouseLocationView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryPackageApi {
	export async function getDeliveryPackageOrNull(args: {
		deliveryPackageId: number;
	}): Promise<DeliveryPackageWithSourcesView | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/getDeliveryPackageOrNull",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
			},
		});
		return response === "" ? null : (response as DeliveryPackageWithSourcesView | null);
	}

	export async function getDeliveryPackageIdForLineSource(args: {
		sourceType: DeliveryPackageLineSourceType;
		sourceId: number;
	}): Promise<number | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/getDeliveryPackageIdForLineSource",
			method: "POST",
			data: {
				sourceType: args.sourceType,
				sourceId: args.sourceId,
			},
		});
		return response === "" ? null : (response as number | null);
	}

	export async function getDeliveryPackageSourceAddress(args: {
		deliveryPackageSource: DeliveryPackageSource;
	}): Promise<Address> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/getDeliveryPackageSourceAddress",
			method: "POST",
			data: {
				deliveryPackageSource: args.deliveryPackageSource,
			},
		});
		return response as Address;
	}

	export async function getPackageLines(args: {
		deliveryPackageId: number;
		deliveryPackageSource?: DeliveryPackageSource | null | undefined;
	}): Promise<Array<DeliveryPackageLineView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/getPackageLines",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
				deliveryPackageSource: args.deliveryPackageSource,
			},
		});
		return response as Array<DeliveryPackageLineView>;
	}

	export async function setPackageStateToPicked(args: { deliveryPackageId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/setPackageStateToPicked",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
			},
		});
		return response as void;
	}

	export async function setPackageStateToUnpicked(args: { deliveryPackageId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/setPackageStateToUnpicked",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
			},
		});
		return response as void;
	}

	export async function printDeliveryPackageLabel(args: {
		deliveryPackageId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/printDeliveryPackageLabel",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printDeliveryPackageShippingLabels(args: {
		deliveryPackageIds: Array<number>;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/printDeliveryPackageShippingLabels",
			method: "POST",
			data: {
				deliveryPackageIds: args.deliveryPackageIds,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function calculateDeliveryPackageWeight(args: { deliveryPackageId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/calculateDeliveryPackageWeight",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
			},
		});
		return response as void;
	}

	export async function movePackagesToDelivery(args: {
		deliveryId: number;
		deliveryPackageIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/movePackagesToDelivery",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
				deliveryPackageIds: args.deliveryPackageIds,
			},
		});
		return response as void;
	}

	export async function removePackagesFromDelivery(args: { deliveryPackageIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/removePackagesFromDelivery",
			method: "POST",
			data: {
				deliveryPackageIds: args.deliveryPackageIds,
			},
		});
		return response as void;
	}

	export async function removePackagesFromBundle(args: { deliveryPackageIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/removePackagesFromBundle",
			method: "POST",
			data: {
				deliveryPackageIds: args.deliveryPackageIds,
			},
		});
		return response as void;
	}

	export async function movePackagesToBundle(args: {
		deliveryPackageIds: Array<number>;
		deliveryPackageBundleId: number;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/movePackagesToBundle",
			method: "POST",
			data: {
				deliveryPackageIds: args.deliveryPackageIds,
				deliveryPackageBundleId: args.deliveryPackageBundleId,
			},
		});
		return response as void;
	}

	export async function setPackageWarehouseLocation(args: {
		deliveryPackageId: number;
		warehouseLocationId: number;
	}): Promise<WarehouseLocationView> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/setPackageWarehouseLocation",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
				warehouseLocationId: args.warehouseLocationId,
			},
		});
		return response as WarehouseLocationView;
	}

	export async function getPackageLinesForCargoDriver(args: {
		deliveryPackageId: number;
	}): Promise<Array<DeliveryPackageLineView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/getPackageLinesForCargoDriver",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
			},
		});
		return response as Array<DeliveryPackageLineView>;
	}

	export async function printDeliveryPackageLabelForCargoDriver(args: {
		deliveryPackageId: number;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/printDeliveryPackageLabelForCargoDriver",
			method: "POST",
			data: {
				deliveryPackageId: args.deliveryPackageId,
			},
		});
		return response as FrontendDownloadFileHandle;
	}

	export async function printDeliveryPackageShippingLabelsForCargoDriver(args: {
		deliveryPackageIds: Array<number>;
	}): Promise<FrontendDownloadFileHandle> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackage/printDeliveryPackageShippingLabelsForCargoDriver",
			method: "POST",
			data: {
				deliveryPackageIds: args.deliveryPackageIds,
			},
		});
		return response as FrontendDownloadFileHandle;
	}
}
